module.exports = __webpack_public_path__ + "img/round-insights-24px.4a16f56f.png";